import CommonButton from './ButtonTypes/CommonButton'
import OutlinedButton from './ButtonTypes/OutlinedButton'
import StandartButton from './ButtonTypes/StandartButton'

export const Button = {
  Standart: StandartButton,
  Outlined: OutlinedButton,
  Common: CommonButton,
}
